import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var EquityFigure =
/*#__PURE__*/
function (_BaseData) {
  _inherits(EquityFigure, _BaseData);

  function EquityFigure() {
    _classCallCheck(this, EquityFigure);

    return _possibleConstructorReturn(this, _getPrototypeOf(EquityFigure).call(this, "EquityFigure"));
  }

  _createClass(EquityFigure, [{
    key: "OneTimeUploadInitialEquity",
    value: function () {
      var _OneTimeUploadInitialEquity = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(ProjectId, OwnersInitialEquity) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                axios.post("/api/".concat(this._controller, "/OneTimeUploadInitialEquity/").concat(ProjectId, "/").concat(OwnersInitialEquity));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function OneTimeUploadInitialEquity(_x, _x2) {
        return _OneTimeUploadInitialEquity.apply(this, arguments);
      }

      return OneTimeUploadInitialEquity;
    }()
  }, {
    key: "OneTimeUploadClosingReport",
    value: function () {
      var _OneTimeUploadClosingReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(ProjectId, ClosingReport) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                axios.post("/api/".concat(this._controller, "/OneTimeUploadClosingReport/").concat(ProjectId, "/").concat(ClosingReport));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function OneTimeUploadClosingReport(_x3, _x4) {
        return _OneTimeUploadClosingReport.apply(this, arguments);
      }

      return OneTimeUploadClosingReport;
    }()
  }, {
    key: "OneTimeUploadCutOffDate",
    value: function () {
      var _OneTimeUploadCutOffDate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(ProjectId, CutOffDate) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                axios.post("/api/".concat(this._controller, "/OneTimeUploadCutOffDate/").concat(ProjectId, "/").concat(CutOffDate));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function OneTimeUploadCutOffDate(_x5, _x6) {
        return _OneTimeUploadCutOffDate.apply(this, arguments);
      }

      return OneTimeUploadCutOffDate;
    }()
  }, {
    key: "UpdateEquityFigures",
    value: function () {
      var _UpdateEquityFigures = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(propertyInfo) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return axios.post("/api/".concat(this._controller, "/UpdateEquityFigures"), propertyInfo);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function UpdateEquityFigures(_x7) {
        return _UpdateEquityFigures.apply(this, arguments);
      }

      return UpdateEquityFigures;
    }()
  }, {
    key: "UploadLoans",
    value: function () {
      var _UploadLoans = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(year, loans) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                axios.post("/api/".concat(this._controller, "/UploadLoans/").concat(year), loans);

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function UploadLoans(_x8, _x9) {
        return _UploadLoans.apply(this, arguments);
      }

      return UploadLoans;
    }()
  }]);

  return EquityFigure;
}(BaseData);

export default new EquityFigure();